import { useSyncExternalStore } from 'react';

/** Below Tailwind's `md` breakpoint (768px): the 280px sidebar cannot fit beside the page. */
let narrowQuery: MediaQueryList | undefined;

function getNarrowQuery(): MediaQueryList {
  narrowQuery ??= window.matchMedia('(max-width: 767px)');
  return narrowQuery;
}

function subscribe(onChange: () => void) {
  const query = getNarrowQuery();
  query.addEventListener('change', onChange);
  return () => query.removeEventListener('change', onChange);
}

/** True while the viewport is narrower than the `md` breakpoint. */
export function useIsNarrowViewport(): boolean {
  return useSyncExternalStore(subscribe, () => getNarrowQuery().matches);
}
